import utils from 'utils'

class templateDetailCtrl {
    constructor($scope, $stateParams, $timeout) {
        const obj = JSON.parse(utils.decode($stateParams.obj))
        $scope.url = `${host.etcloudBiReport}ReportServer?reportlet=${obj.path}&op=view`
        const index = obj.item
        $(() => {
            $('body').addClass('leftnav-close ie11-overflow')
            $('#wrapper').addClass('top-nav-close')
            $timeout(() => {
                const iframe = document.querySelector('#templateDetail')
                console.log(iframe)
                iframe.attachEvent = iframe.attachEvent || 0
                if (iframe.attachEvent) {
                    iframe.attachEvent('onload', () => {
                        const document = iframe.contentDocument || iframe.contentWindow.document
                        $(document.querySelectorAll('.fr-sheetbutton-middlepart'))[index].click()
                    })
                } else {
                    iframe.onload = function () {
                        const document = iframe.contentDocument || iframe.contentWindow.document
                        $(document.querySelectorAll('.fr-sheetbutton-middlepart'))[index].click()
                    }
                }
            })
        })
    }
}

templateDetailCtrl.$inject = ['$scope', '$stateParams', '$timeout']
export default templateDetailCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/templateSetting/templateDetailCtrl.js